// External Dependencies:
import React from 'react'
import { Link } from 'react-router-dom'
import Waypoint from 'react-waypoint'

// Internal Dependencies:
import Image from 'church-theme-library/components/Image/Image'

class PostRow extends React.Component {
	constructor() {
		super()

		this.state = {
			wapointEntered: false
		}
	}

	handleWaypointEnter = () => {
		const { wapointEntered } = this.state

		// Only trigger once:
		if ( wapointEntered ) {
			return
		}

		this.setState({
			wapointEntered: true
		})

		this.props.handleWaypointEnter()
	}

	handleClick = ( e ) => {
		if ( this.props.onClick ) {
			this.props.onClick( e )
		}
	}

	render() {
		let {
			url,
			title,
			author,
			dateData,
			dateRecurText,
			locationLabel,
			image,
			imageAlt,
			excerpt,
			direction,
			size,
			order,
			className,
			wrapClassName,
			sizes
		} = this.props
		let theClassName = 'post-row'
		let theWrapClassName = 'post-row-wrap'
		let theOrder = order ? order : 'image-text'
		let sizesBase = `(max-width: ${siteData.mobile_max_width}px) 100vw`
		let theSizes = `${sizesBase}, 200px`

		if ( sizes ) {
			theSizes = sizes
		}

		theClassName += ` is-${theOrder}`

		if ( size ) {
			theClassName += ` is-${size}`
			theWrapClassName += ` is-${size}`
		}

		if ( image && image.url ) {
			theClassName += ' with-image'
		} else {
			theClassName += ' without-image'
		}

		if ( wrapClassName ) {
			theWrapClassName += ` ${wrapClassName}`
		}

		if ( className ) {
			theClassName += ` ${className}`
		}

		return (
			<div className={ theWrapClassName }>
				<Link className={ theClassName } to={ url } onClick={ this.handleClick }>
					{ this.props.handleWaypointEnter &&
						<Waypoint
							onEnter={ this.handleWaypointEnter }
						/>
					}

					<div className="-date-wrap">
						{ dateData && dateData.m &&
							<div className="-date">
								<p className="-m">{ dateData.m }</p>
								<p className="-d">{ dateData.d }</p>
							</div>
						}

						<div className="-meta">
							{ dateRecurText &&
								<div className="-recur">
									<i className="icon-calendar" aria-hidden="true"></i>

									<p>{ dateRecurText }</p>
								</div>
							}

							{ locationLabel &&
								<div className="-location-label">
									<i className="icon-ios-navigate" aria-hidden="true"></i>

									<p>{ locationLabel }</p>
								</div>
							}
						</div>
					</div>

					<div className="-text">
						<h3 className="-title">{ title }</h3>

						{ excerpt &&
							<p className="-excerpt" dangerouslySetInnerHTML={ { __html: excerpt } } />
						}

						{ author &&
							<p className="-author">{ author }</p>
						}
					</div>

					{ image && image.url &&
						<div className="-image">
							<Image
								thumb={ image.thumb }
								thumbWebp={ image.thumb_webp }
								url={ image.url }
								srcset={ image.srcset }
								srcsetWebp={ image.srcset_webp }
								sizes={ theSizes }
								alt={ imageAlt }
								focalPoint={ image.focal_point }
								width={ image.width }
								height={ image.height }
							/>
						</div>
					}
				</Link>
			</div>
		)
	}
}

export default PostRow
